export function isAdvisorAccountActivationEntryEnabled({
  clientProfiles,
  clientRolloutEnabled,
}: {
  clientProfiles: ClientProfile[] | null | undefined;
  clientRolloutEnabled: boolean;
}): boolean {
  const hasNylClientProfile =
    clientProfiles?.some(profile => profile.clientAdvisor.featureFlags?.nylPilotAdvisor === true) ??
    false;

  if (hasNylClientProfile) {
    return false;
  }

  const hasNonD2CClientProfile =
    clientProfiles?.some(profile => profile.clientAdvisor.featureFlags?.d2cMode !== true) ?? false;

  return hasNonD2CClientProfile || clientRolloutEnabled;
}
